import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";
import { csvCharField } from "../csv-char-field";

export const csvDataSourceWriterStep = defineStepConfig({
  type: "csv_datasource_writer",
  name: "Csv DataSource Writer",
  description:
    "Load CSV data from a Blob Storage URI into a configured DataIngestLink target.",
  category: "DataSource Writer",

  inputSchema: z.object({
    blobStorageUri: z
      .string()
      .describe("Blob Storage URI of the CSV file to load"),
    storageProfile: z
      .string()
      .describe(
        "Storage profile key that identifies the credentials to use to access the Blob Storage URI",
      ),
    dataSourceLink: z
      .string()
      .uuid()
      .describe("DataIngestLink that identifies the target schema + table"),
    csvOptions: z
      .object({
        delimiter: csvCharField
          .prefault(",")
          .describe("Column delimiter character"),
        quote: csvCharField
          .prefault('"')
          .describe("Quote character used to wrap fields"),
        encoding: z
          .enum([
            "utf8",
            "utf-8",
            "utf16le",
            "latin1",
            "ascii",
            "base64",
            "hex",
          ])
          .prefault("utf8")
          .describe("Character encoding of the CSV file"),
      })
      .prefault({}),
  }),

  outputSchema: z.object({}),

  configSchema: z.object({
    batchSize: z
      .number()
      .int()
      .positive()
      .prefault(500)
      .describe("Number of records per write batch"),
  }),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "10 minutes",
    retry: {
      maximumAttempts: 3,
      backoffCoefficient: 2,
      initialInterval: "10 seconds",
    },
  },
});
